import { useTranslation } from 'react-i18next';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
//////////////////////////////////////////////////////////////////
import {
	Button,
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogOverlay,
	DialogTitle,
	PageTitle,
	ProductsList,
} from '@/app/shared/components';

interface InsufficientGemsProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const InsufficientGems: React.FC<InsufficientGemsProps> = ({
	isOpen,
	onClose,
}) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region States
	**********************/

	// const [sticker, setSticker] = useState<ClaimGift>({
	// 	collection: '',
	// 	collectionTitle: '',
	// 	isCollectionCompleted: false,
	// 	isStickerRepeated: false,
	// 	sticker: {
	// 		position: 1,
	// 		image: '',
	// 	},
	// });

	/*********************
	// #region Observables
	**********************/

	/*********************
	// #region Functions
	**********************/

	/*********************
	// #region Template
	**********************/
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogOverlay className="bg-customer-950/70" />
			<DialogContent
				className="border-none bg-transparent lg:max-w-screen-lg overflow-y-scroll max-h-screen"
				onInteractOutside={(event) => event.preventDefault()}
			>
				<DialogHeader>
					<DialogTitle>
						<VisuallyHidden.Root>
							{t('general.giftWon')}
						</VisuallyHidden.Root>
					</DialogTitle>
					<DialogDescription className="text-lg text-slate-100 p-0 mt-0 m-0 leading-1 space-y-0">
						<VisuallyHidden.Root>
							{t('general.giftWon')}
						</VisuallyHidden.Root>
					</DialogDescription>
				</DialogHeader>
				<div
					className={`flex flex-col items-center space-x-2 transition-opacity duration-1000 ease-in-out`}
				>
					<div className="mb-6">
						<div className="flex flex-col items-center">
							<PageTitle>
								{t('shop.insufficientGems.title')}
							</PageTitle>
						</div>

						<p className="text-slate-300 text-sm">
							{t('shop.insufficientGems.description')}
						</p>
					</div>

					<div className="mb-6">
						<ProductsList />
					</div>

					<DialogClose asChild>
						<Button type="button" variant="secondary">
							{t('general.close')}
						</Button>
					</DialogClose>
				</div>
			</DialogContent>
		</Dialog>
	);
};
